import React from 'react';
import './TopPerformerTile.css';
import { Box, Avatar, Typography } from '@mui/material';
import { fonts } from '../../themes/themes';

interface contentTileType {
  pic: string;
  name: string;
  designation: string;
  value: number;
}
const TopPerformerTile: React.FC<contentTileType> = ({
  pic,
  name,
  value,
  designation,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.5em',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box>
          <Avatar
            src={pic}
            style={{
              background: 'transparent 0% 0% no-repeat padding-box',
              boxShadow: '0px 3px 6px #00000029',
              border: '3px solid #ffffff',
              height: '3em',
              width: '3em',
              borderRadius: '50%',
            }}
          />
        </Box>
        <Box sx={{ marginLeft: '0.5em' }}>
          <Typography
            style={{
              color: '#081735',
              fontFamily: fonts.fontFamily,
              fontSize: '0.825em',
              fontWeight: 'bold',
            }}
          >
            {name}
          </Typography>
          <Typography
            style={{
              color: '#9E9E9E',
              fontFamily: fonts.fontFamily,
              fontSize: '0.725em',
            }}
          >
            {designation}
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          border: '1px solid #4CAF50',
          textAlign: 'center',
          padding: '0.3em',
          borderRadius: '15%',
        }}
      >
        <Typography
          style={{
            color: '#4CAF50',
            fontFamily: fonts.fontFamily,
            fontSize: '0.825em',
          }}
        >
          {value}%
        </Typography>
      </Box>
    </Box>
  );
};

export default TopPerformerTile;
